import styled, { css } from 'styled-components';

export const screenReaderOnlyStyles = css`
  position: absolute;
  left: -10000px;
  top: auto;
  width: 1px;
  height: 1px;
  overflow: hidden;
`;

export const InvisibleTable = styled.table`
  ${screenReaderOnlyStyles}
`;
